import { TIMESPAN } from '@/enums/timespan';
import { ChartDataResponse } from '@/services/types/investment';

const filterByStartDate = <T>(data: T[], dateKey: keyof T, threshold: Date): T[] => {
  return data.filter((item) => {
    const dateValue = item[dateKey];
    if (dateValue) {
      return new Date(dateValue as string) >= threshold;
    }
    return false;
  });
};

export const getDisplayedData = (data: ChartDataResponse[], timespan: TIMESPAN): ChartDataResponse[] => {
  const today = new Date();
  let startIndex: number;
  let startDate: Date;

  switch (timespan) {
    // Default
    case TIMESPAN.week:
      // On évite les indexs négatifs
      startIndex = Math.max(0, data.length - 7);
      // On prend le nombre d'enregistrements demandés
      return data.slice(startIndex, data.length);

    case TIMESPAN.month:
      startIndex = Math.max(0, data.length - 30);
      return data.slice(startIndex, data.length);

    case TIMESPAN.year:
      // Get all points starting from 1st january of the current year
      startDate = new Date(today.getFullYear(), 0, 1);

      return filterByStartDate(data, 'd', startDate);

    // Immobilier
    case TIMESPAN.fiveYears:
      // Get all pints starting from 5 years ago
      startDate = new Date(today.getFullYear() - 5, today.getMonth(), today.getDay());

      return filterByStartDate(data, 'dateVL', startDate);

    case TIMESPAN.tenYears:
      // Get all pints starting from 10 years ago
      startDate = new Date(today.getFullYear() - 10, today.getMonth(), today.getDay());

      return filterByStartDate(data, 'dateVL', startDate);

    case TIMESPAN.fifteenYears:
      // Get all pints starting from 15 years ago
      startDate = new Date(today.getFullYear() - 15, today.getMonth(), today.getDay());

      return filterByStartDate(data, 'dateVL', startDate);

    // Toutes les data
    case TIMESPAN.allTime:
      return data.slice(0, data.length);

    default:
      return data.slice(-30);
  }
};
